import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@du/ui/fontes.css'
import '@du/ui/tokens.css'
import '@du/ui/componentes.css'
import './global.css'
import { App } from './App.js'
import { ProvedorCarrinho } from './lib/carrinho.js'

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <BrowserRouter>
      <ProvedorCarrinho>
        <App />
      </ProvedorCarrinho>
    </BrowserRouter>
  </StrictMode>,
)
